import React from "react";

import ObjetivoV2AccordionCard from "./ObjetivoV2AccordionCard";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";

const MODOS_FILTRO = [
  {
    value: "",
    label: "Todos",
  },
  {
    value: "INCLUIR",
    label: "Incluir apenas",
  },
  {
    value: "EXCLUIR",
    label: "Excluir apenas",
  },
];

export default function ObjetivoV2UniversoClientes({
  isEdicao,
  filtros,
  bloqueios,

  catalogoSegmentos,
  catalogoGruposClientes,
  catalogoBloqueiosFornecimento,
  catalogoBloqueiosFaturacao,
  catalogoBloqueiosOrdem,

  clientesOpcoes,
  clienteTermo,
  loadingClientes,

  guardarFiltroObjetivo,
  guardarBloqueiosObjetivo,
  pesquisarClientes,
}) {
  const obterFiltro = (tipo) => {
    const linhas = filtros.filter(
      (x) =>
        String(x?.tipo || "")
          .trim()
          .toUpperCase() === tipo
    );

    return {
      sentido:
        linhas.length > 0
          ? String(linhas[0]?.sentido || "")
              .trim()
              .toUpperCase()
          : "",

      valores: linhas.map((x) => String(x?.valor || "").trim()).filter(Boolean),
    };
  };

  const obterBloqueios = (tipo) =>
    bloqueios
      .filter(
        (x) =>
          String(x?.tipo || "")
            .trim()
            .toUpperCase() === tipo
      )
      .map((x) => String(x?.valor || "").trim())
      .filter(Boolean);

  const filtroSegmentoPotencial = obterFiltro("SEGMENTO_POTENCIAL");
  const filtroSegmentoN1 = obterFiltro("SEGMENTO_N1");
  const filtroSegmentoN2 = obterFiltro("SEGMENTO_N2");
  const filtroSegmentoN3 = obterFiltro("SEGMENTO_N3");
  const filtroGruposClientes = obterFiltro("GRUPO_CLIENTE");
  const filtroClientes = obterFiltro("CLIENTE");
  const filtroConsumidorFinal = obterFiltro("CONSUMIDOR_FINAL");

  const bloqueiosFornecimento = obterBloqueios("FORNECIMENTO");
  const bloqueiosFaturacao = obterBloqueios("FATURACAO");
  const bloqueiosOrdem = obterBloqueios("ORDEM");

  return (
    <ObjetivoV2AccordionCard titulo="Universo de clientes">
      <MDBox
        display="grid"
        gridTemplateColumns={{
          xs: "1fr",
          md: "220px minmax(0, 1fr)",
        }}
        gap={2}
        alignItems="start"
      >
        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Segmento Potencial
          </MDTypography>

          <Autocomplete
            size="small"
            options={MODOS_FILTRO}
            getOptionLabel={(option) => option?.label || ""}
            value={
              MODOS_FILTRO.find((x) => x.value === filtroSegmentoPotencial.sentido) ||
              MODOS_FILTRO[0]
            }
            onChange={async (_, value) => {
              const novoSentido = value?.value || "";

              await guardarFiltroObjetivo(
                "SEGMENTO_POTENCIAL",
                novoSentido,
                novoSentido === "" ? [] : filtroSegmentoPotencial.valores
              );
            }}
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
            disableClearable
            disabled={!isEdicao}
            renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Valores
          </MDTypography>

          <Autocomplete
            multiple
            size="small"
            options={catalogoSegmentos.filter(
              (x) =>
                String(x?.tipo || "")
                  .trim()
                  .toUpperCase() === "SEGMENTO_POTENCIAL"
            )}
            getOptionLabel={(option) => option?.nome || option?.valor || option?.ref || ""}
            value={catalogoSegmentos.filter((option) =>
              filtroSegmentoPotencial.valores.includes(
                String(option?.valor || option?.ref || "").trim()
              )
            )}
            onChange={async (_, values) => {
              const refs = values
                .map((x) => String(x?.valor || x?.ref || "").trim())
                .filter(Boolean);

              await guardarFiltroObjetivo(
                "SEGMENTO_POTENCIAL",
                filtroSegmentoPotencial.sentido || "INCLUIR",
                refs
              );
            }}
            isOptionEqualToValue={(option, value) =>
              String(option?.valor || option?.ref || "") ===
              String(value?.valor || value?.ref || "")
            }
            disableCloseOnSelect
            disabled={!isEdicao || filtroSegmentoPotencial.sentido === ""}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={filtroSegmentoPotencial.sentido === "" ? "Todos" : "Selecione..."}
              />
            )}
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Segmento N1
          </MDTypography>

          <Autocomplete
            size="small"
            options={MODOS_FILTRO}
            getOptionLabel={(option) => option?.label || ""}
            value={
              MODOS_FILTRO.find((x) => x.value === filtroSegmentoN1.sentido) || MODOS_FILTRO[0]
            }
            onChange={async (_, value) => {
              const novoSentido = value?.value || "";

              await guardarFiltroObjetivo(
                "SEGMENTO_N1",
                novoSentido,
                novoSentido === "" ? [] : filtroSegmentoN1.valores
              );
            }}
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
            disableClearable
            disabled={!isEdicao}
            renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Valores
          </MDTypography>

          <Autocomplete
            multiple
            size="small"
            options={catalogoSegmentos.filter(
              (x) =>
                String(x?.tipo || "")
                  .trim()
                  .toUpperCase() === "SEGMENTO_N1"
            )}
            getOptionLabel={(option) => option?.valor || ""}
            value={catalogoSegmentos.filter(
              (option) =>
                String(option?.tipo || "")
                  .trim()
                  .toUpperCase() === "SEGMENTO_N1" &&
                filtroSegmentoN1.valores.includes(String(option?.valor || "").trim())
            )}
            onChange={async (_, values) => {
              const refs = values.map((x) => String(x?.valor || "").trim()).filter(Boolean);

              await guardarFiltroObjetivo(
                "SEGMENTO_N1",
                filtroSegmentoN1.sentido || "INCLUIR",
                refs
              );
            }}
            isOptionEqualToValue={(option, value) =>
              String(option?.valor || "") === String(value?.valor || "")
            }
            disableCloseOnSelect
            disabled={!isEdicao || filtroSegmentoN1.sentido === ""}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={filtroSegmentoN1.sentido === "" ? "Todos" : "Selecione..."}
              />
            )}
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Segmento N2
          </MDTypography>

          <Autocomplete
            size="small"
            options={MODOS_FILTRO}
            getOptionLabel={(option) => option?.label || ""}
            value={
              MODOS_FILTRO.find((x) => x.value === filtroSegmentoN2.sentido) || MODOS_FILTRO[0]
            }
            onChange={async (_, value) => {
              const novoSentido = value?.value || "";

              await guardarFiltroObjetivo(
                "SEGMENTO_N2",
                novoSentido,
                novoSentido === "" ? [] : filtroSegmentoN2.valores
              );
            }}
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
            disableClearable
            disabled={!isEdicao}
            renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Valores
          </MDTypography>

          <Autocomplete
            multiple
            size="small"
            options={catalogoSegmentos.filter(
              (x) =>
                String(x?.tipo || "")
                  .trim()
                  .toUpperCase() === "SEGMENTO_N2"
            )}
            getOptionLabel={(option) => option?.valor || ""}
            value={catalogoSegmentos.filter(
              (option) =>
                String(option?.tipo || "")
                  .trim()
                  .toUpperCase() === "SEGMENTO_N2" &&
                filtroSegmentoN2.valores.includes(String(option?.valor || "").trim())
            )}
            onChange={async (_, values) => {
              const refs = values.map((x) => String(x?.valor || "").trim()).filter(Boolean);

              await guardarFiltroObjetivo(
                "SEGMENTO_N2",
                filtroSegmentoN2.sentido || "INCLUIR",
                refs
              );
            }}
            isOptionEqualToValue={(option, value) =>
              String(option?.valor || "") === String(value?.valor || "")
            }
            disableCloseOnSelect
            disabled={!isEdicao || filtroSegmentoN2.sentido === ""}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={filtroSegmentoN2.sentido === "" ? "Todos" : "Selecione..."}
              />
            )}
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Segmento N3
          </MDTypography>

          <Autocomplete
            size="small"
            options={MODOS_FILTRO}
            getOptionLabel={(option) => option?.label || ""}
            value={
              MODOS_FILTRO.find((x) => x.value === filtroSegmentoN3.sentido) || MODOS_FILTRO[0]
            }
            onChange={async (_, value) => {
              const novoSentido = value?.value || "";

              await guardarFiltroObjetivo(
                "SEGMENTO_N3",
                novoSentido,
                novoSentido === "" ? [] : filtroSegmentoN3.valores
              );
            }}
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
            disableClearable
            disabled={!isEdicao}
            renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Valores
          </MDTypography>

          <Autocomplete
            multiple
            size="small"
            options={catalogoSegmentos.filter(
              (x) =>
                String(x?.tipo || "")
                  .trim()
                  .toUpperCase() === "SEGMENTO_N3"
            )}
            getOptionLabel={(option) => option?.valor || ""}
            value={catalogoSegmentos.filter(
              (option) =>
                String(option?.tipo || "")
                  .trim()
                  .toUpperCase() === "SEGMENTO_N3" &&
                filtroSegmentoN3.valores.includes(String(option?.valor || "").trim())
            )}
            onChange={async (_, values) => {
              const refs = values.map((x) => String(x?.valor || "").trim()).filter(Boolean);

              await guardarFiltroObjetivo(
                "SEGMENTO_N3",
                filtroSegmentoN3.sentido || "INCLUIR",
                refs
              );
            }}
            isOptionEqualToValue={(option, value) =>
              String(option?.valor || "") === String(value?.valor || "")
            }
            disableCloseOnSelect
            disabled={!isEdicao || filtroSegmentoN3.sentido === ""}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={filtroSegmentoN3.sentido === "" ? "Todos" : "Selecione..."}
              />
            )}
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Grupos de clientes
          </MDTypography>

          <Autocomplete
            size="small"
            options={MODOS_FILTRO}
            getOptionLabel={(option) => option?.label || ""}
            value={
              MODOS_FILTRO.find((x) => x.value === filtroGruposClientes.sentido) || MODOS_FILTRO[0]
            }
            onChange={async (_, value) => {
              const novoSentido = value?.value || "";

              await guardarFiltroObjetivo(
                "GRUPO_CLIENTE",
                novoSentido,
                novoSentido === "" ? [] : filtroGruposClientes.valores
              );
            }}
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
            disableClearable
            disabled={!isEdicao}
            renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Valores
          </MDTypography>

          <Autocomplete
            multiple
            size="small"
            options={catalogoGruposClientes}
            getOptionLabel={(option) =>
              option?.nome ? `${option.ref} - ${option.nome}` : option?.ref || ""
            }
            value={catalogoGruposClientes.filter((option) =>
              filtroGruposClientes.valores.includes(String(option?.ref || "").trim())
            )}
            onChange={async (_, values) => {
              const refs = values.map((x) => String(x?.ref || "").trim()).filter(Boolean);

              await guardarFiltroObjetivo(
                "GRUPO_CLIENTE",
                filtroGruposClientes.sentido || "INCLUIR",
                refs
              );
            }}
            isOptionEqualToValue={(option, value) =>
              String(option?.ref || "") === String(value?.ref || "")
            }
            disableCloseOnSelect
            disabled={!isEdicao || filtroGruposClientes.sentido === ""}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={filtroGruposClientes.sentido === "" ? "Todos" : "Selecione..."}
              />
            )}
          />
        </MDBox>

        <MDBox display="flex" alignItems="center" minHeight={40}>
          <MDTypography variant="caption" color="text" display="block">
            Consumidores finais / particulares
          </MDTypography>
        </MDBox>

        <MDBox display="flex" alignItems="center" minHeight={40}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={
                  filtroConsumidorFinal.sentido === "EXCLUIR" &&
                  filtroConsumidorFinal.valores.includes("SIM")
                }
                disabled={!isEdicao}
                onChange={async (e) => {
                  await guardarFiltroObjetivo(
                    "CONSUMIDOR_FINAL",
                    e.target.checked ? "EXCLUIR" : "",
                    e.target.checked ? ["SIM"] : []
                  );
                }}
              />
            }
            label="Excluir consumidores finais / particulares"
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "0.875rem",
              },
            }}
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Clientes específicos
          </MDTypography>

          <Autocomplete
            size="small"
            options={MODOS_FILTRO}
            getOptionLabel={(option) => option?.label || ""}
            value={MODOS_FILTRO.find((x) => x.value === filtroClientes.sentido) || MODOS_FILTRO[0]}
            onChange={async (_, value) => {
              const novoSentido = value?.value || "";

              await guardarFiltroObjetivo(
                "CLIENTE",
                novoSentido,
                novoSentido === "" ? [] : filtroClientes.valores
              );
            }}
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
            disableClearable
            disabled={!isEdicao}
            renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
          />
        </MDBox>

        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Clientes
          </MDTypography>

          <Autocomplete
            multiple
            size="small"
            options={clientesOpcoes}
            loading={loadingClientes}
            filterOptions={(options) => options}
            getOptionLabel={(option) => {
              const ref = String(option?.ref || "").trim();
              const nome = String(option?.nome || "").trim();
              const nif = String(option?.nif || "").trim();

              if (nome && nif) {
                return `${ref} - ${nome} - ${nif}`;
              }

              if (nome) {
                return `${ref} - ${nome}`;
              }

              return ref;
            }}
            value={filtroClientes.valores.map((ref) => {
              const encontrado = clientesOpcoes.find(
                (option) => String(option?.ref || "").trim() === String(ref || "").trim()
              );

              return (
                encontrado || {
                  ref,
                  nome: "",
                  nif: "",
                }
              );
            })}
            onInputChange={(_, value, reason) => {
              if (reason === "input") {
                pesquisarClientes(value);
              }
            }}
            onChange={async (_, values) => {
              const refs = values.map((x) => String(x?.ref || "").trim()).filter(Boolean);

              await guardarFiltroObjetivo("CLIENTE", filtroClientes.sentido || "INCLUIR", refs);
            }}
            isOptionEqualToValue={(option, value) =>
              String(option?.ref || "") === String(value?.ref || "")
            }
            disableCloseOnSelect
            disabled={!isEdicao || filtroClientes.sentido === ""}
            noOptionsText={
              clienteTermo.length < 2
                ? "Escreve pelo menos 2 caracteres."
                : "Nenhum cliente encontrado."
            }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={filtroClientes.sentido === "" ? "Todos" : "Pesquisar cliente..."}
              />
            )}
          />
        </MDBox>

        <MDBox display="flex" alignItems="center" minHeight={40}>
          <MDTypography variant="caption" color="text" display="block">
            Bloqueios de fornecimento (exclusão de clientes)
          </MDTypography>
        </MDBox>

        <MDBox display="flex" flexWrap="wrap" alignItems="center" gap={0.5} minHeight={40}>
          {catalogoBloqueiosFornecimento.map((option) => {
            const ref = String(option?.ref || "").trim();
            const selecionado = bloqueiosFornecimento.includes(ref);

            return (
              <FormControlLabel
                key={ref}
                control={
                  <Checkbox
                    size="small"
                    checked={selecionado}
                    disabled={!isEdicao}
                    onChange={async (e) => {
                      const refs = e.target.checked
                        ? [...bloqueiosFornecimento, ref]
                        : bloqueiosFornecimento.filter((x) => x !== ref);

                      await guardarBloqueiosObjetivo("FORNECIMENTO", refs);
                    }}
                  />
                }
                label={option?.nome ? `${ref} - ${option.nome}` : ref}
                sx={{
                  mr: 2,
                  "& .MuiFormControlLabel-label": {
                    fontSize: "0.875rem",
                  },
                }}
              />
            );
          })}
        </MDBox>

        <MDBox display="flex" alignItems="center" minHeight={40}>
          <MDTypography variant="caption" color="text" display="block">
            Bloqueios de faturação (exclusão de clientes)
          </MDTypography>
        </MDBox>

        <MDBox display="flex" flexWrap="wrap" alignItems="center" gap={0.5} minHeight={40}>
          {catalogoBloqueiosFaturacao.map((option) => {
            const ref = String(option?.ref || "").trim();
            const selecionado = bloqueiosFaturacao.includes(ref);

            return (
              <FormControlLabel
                key={ref}
                control={
                  <Checkbox
                    size="small"
                    checked={selecionado}
                    disabled={!isEdicao}
                    onChange={async (e) => {
                      const refs = e.target.checked
                        ? [...bloqueiosFaturacao, ref]
                        : bloqueiosFaturacao.filter((x) => x !== ref);

                      await guardarBloqueiosObjetivo("FATURACAO", refs);
                    }}
                  />
                }
                label={option?.nome ? `${ref} - ${option.nome}` : ref}
                sx={{
                  mr: 2,
                  "& .MuiFormControlLabel-label": {
                    fontSize: "0.875rem",
                  },
                }}
              />
            );
          })}
        </MDBox>

        <MDBox display="flex" alignItems="center" minHeight={40}>
          <MDTypography variant="caption" color="text" display="block">
            Bloqueios de ordem (exclusão de clientes)
          </MDTypography>
        </MDBox>

        <MDBox display="flex" flexWrap="wrap" alignItems="center" gap={0.5} minHeight={40}>
          {catalogoBloqueiosOrdem.map((option) => {
            const ref = String(option?.ref || "").trim();
            const selecionado = bloqueiosOrdem.includes(ref);

            return (
              <FormControlLabel
                key={ref}
                control={
                  <Checkbox
                    size="small"
                    checked={selecionado}
                    disabled={!isEdicao}
                    onChange={async (e) => {
                      const refs = e.target.checked
                        ? [...bloqueiosOrdem, ref]
                        : bloqueiosOrdem.filter((x) => x !== ref);

                      await guardarBloqueiosObjetivo("ORDEM", refs);
                    }}
                  />
                }
                label={option?.nome ? `${ref} - ${option.nome}` : ref}
                sx={{
                  mr: 2,
                  "& .MuiFormControlLabel-label": {
                    fontSize: "0.875rem",
                  },
                }}
              />
            );
          })}
        </MDBox>
      </MDBox>
    </ObjetivoV2AccordionCard>
  );
}
